module.exports = __webpack_public_path__ + "img/sunny milk_lw.230f8231.png";